import React from 'react';
import classNames from 'classnames';

import { useAccordionContext } from '../accordionContext';

import styles from './accordionStyles.scss';

const AccordionContent: React.FunctionComponent<{
  children?: React.ReactNode;
  customStyles?: string;
}> = ({ children, customStyles }): React.ReactElement => {
  const { isExpanded } = useAccordionContext();
  return (
    <div
      className={classNames(styles.content, { [styles.contentExpanded]: isExpanded }, customStyles)}
    >
      {children}
    </div>
  );
};

export default AccordionContent;
